import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { colors } from '~/components/utils/colors';
import { TableGridSpacing } from '~/components/pages/client/Sections/ExpandableTable/ExpandableTable.style';

export const style = {
  name: css({
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
    color: colors.colorPriOne,
    minHeight: '32px',
    display: 'flex',
    alignItems: 'center',
  }),
  column: css({
    fontSize: '13px',
    lineHeight: '19px',
    fontWeight: 500,
    color: colors.colorGsThree,
    minHeight: '32px',
    display: 'flex',
    alignItems: 'center',
  }),
  list: css({
    gridColumn: '3 / span 5',
    display: 'grid',
    alignItems: 'center',
    gap: '10px'
  }),
  actions: css({
    placeSelf: 'self-end',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    alignSelf: 'auto',
  }),
  disabled: css({
    opacity: 0.6,
  }),
  innerRow: css({
    paddingLeft: 0
  })
};

export const TestResultRow = styled(TableGridSpacing)`
  color: ${colors.colorGsThree};
  align-items: flex-start;
`;

export const TestResultListItem = styled(TableGridSpacing)`
  padding: 0;
`;
